const ProjectTitle = ({ title }: { title: string }) => {
  return (
    <div className="group relative inline-block w-fit cursor-pointer text-3xl leading-none mb-16">
      <h3 className="text-blank-yellow">{title}</h3>
      <span
        className="
          absolute top-0 left-0 w-full h-full bg-blank-yellow origin-left scale-x-0 transform transition-transform duration-1000 ease-spring will-change-transform z-10 group-hover:scale-x-100"
        aria-hidden
      />
      <span
        className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-blank-black [clip-path:inset(0_100%_0_0)] transition-[clip-path] will-change-auto duration-900 ease-spring z-20 group-hover:[clip-path:inset(0_0_0_0)]"
        aria-hidden
      >
        {title}
      </span>
    </div>
  );
};

export default ProjectTitle;
